import { withNamespaces } from "react-i18next";
import { Button, Spinner } from "reactstrap";
import CancelCreateModal from "./CancelCreateModal";
import { useState } from "react";

const ButtonsGroup = ({ 
    t, 
    onBackClicked, 
    onNextClicked, 
    onSaveClicked, 
    nextButtonType, 
    nextIsDisabled, 
    isLoading 
}) => {
    const [showCancelModal, setShowCancelModal] = useState(false);

    return (
        <div className="mt-3 d-flex justify-content-between">
            <Button
                color="secondary"
                outline
                onClick={() => setShowCancelModal(true)}
            >
                {t('Cancel')}
            </Button>

            <div>
                {onBackClicked && (
                    <Button
                        color="secondary"
                        onClick={onBackClicked}
                        className="me-2"
                        disabled={isLoading}
                    >
                        {t('Back')}
                    </Button>
                )}

                {onSaveClicked && (
                    <Button
                        color="primary"
                        className="ms-2"
                        onClick={onSaveClicked}
                        disabled={isLoading}
                    >
                        {isLoading && (
                            <Spinner
                                color="white"
                                size="sm"
                                className="me-1"
                            />
                        )}
                        {t('Save')}
                    </Button>
                )}

                {onNextClicked && (
                    <Button 
                        color="primary"
                        className="ms-2"
                        type={nextButtonType ? nextButtonType : 'button'}
                        disabled={isLoading || nextIsDisabled}
                        onClick={onNextClicked}
                    >
                        {t('Next')}
                    </Button>
                )}
            </div>

            <CancelCreateModal 
                isOpen={showCancelModal}
                toggle={() => setShowCancelModal(!showCancelModal)}
            />
        </div>
    )
}

export default withNamespaces()(
    ButtonsGroup
);